import { render, staticRenderFns } from "./FacturarDialogProduction.vue?vue&type=template&id=13b3c0bc&scoped=true"
import script from "./FacturarDialogProduction.vue?vue&type=script&lang=js"
export * from "./FacturarDialogProduction.vue?vue&type=script&lang=js"
import style0 from "./FacturarDialogProduction.vue?vue&type=style&index=0&id=13b3c0bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b3c0bc",
  null
  
)

export default component.exports